import type { ComponentType } from 'react';
import type { CreateBodyProps } from './createBodyProps';
import { CollectionBody } from './CollectionBody';
import { EquipmentBody } from './EquipmentBody';
import { ImportBody } from './ImportBody';
import { LinkBody } from './LinkBody';
import { PhoneBody } from './PhoneBody';
import { PhotoBody } from './PhotoBody';
import { ProtocolBody } from './ProtocolBody';
import { SpreadsheetBody } from './SpreadsheetBody';

/**
 * Step 2 bodies by registry id. A type with no body commits straight from
 * step 1 (voice, text note): one click, as before. Adding a type with a form = one entry here.
 */
export const CREATE_BODIES: Readonly<Record<string, ComponentType<CreateBodyProps>>> = {
  collection: CollectionBody,
  import: ImportBody,
  protocol: ProtocolBody,
  spreadsheet: SpreadsheetBody,
  equipment: EquipmentBody,
  link: LinkBody,
  phone: PhoneBody,
  photo: PhotoBody,
};
